import { render, staticRenderFns } from "./ModalEditCategory.vue?vue&type=template&id=7b25e13e&scoped=true"
import script from "./ModalEditCategory.vue?vue&type=script&lang=js"
export * from "./ModalEditCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalEditCategory.vue?vue&type=style&index=0&id=7b25e13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b25e13e",
  null
  
)

export default component.exports